import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center justify-center"
}
const _hoisted_2 = { class: "mr-2" }
const _hoisted_3 = { class: "" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-center justify-center mb-5"
}
const _hoisted_5 = { class: "ml-4" }
const _hoisted_6 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_7 = {
  key: 1,
  class: "ml-4"
}
const _hoisted_8 = { class: "milk-modal-time-field" }
const _hoisted_9 = { class: "d-flex align-baseline" }
const _hoisted_10 = { class: "d-flex align-baseline" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_time_picker = _resolveComponent("v-time-picker")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!

  return (_openBlock(), _createBlock(_component_v_card_text, {
    class: _normalizeClass(['py-3', { 'en-card-text-padding': _ctx.$i18n.locale === 'en' }])
  }, {
    default: _withCtx(() => [
      (_ctx.milkTemp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('milk.beforeCorrection')), 1),
            _createVNode(_component_v_chip, {
              color: "milk",
              class: "mr-2",
              variant: "outlined",
              size: "x-small"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('milk.milkTypeLabel')), 1)
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatTime(_ctx.milkTemp.recordedAt)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.milkTemp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.milkTemp.amount ? _ctx.milkTemp.amount.value + 'cc' : _ctx.$t('milk.unknown')), 1),
            (_ctx.milkTemp.milkCategory == 'formula')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('milk.formulaPowderMilk')), 1))
              : _createCommentVNode("", true),
            (_ctx.milkTemp.milkCategory == 'breast')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('milk.breastMilk')), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_v_menu, {
          modelValue: _ctx.isRecordetAtPicker,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isRecordetAtPicker) = $event)),
          "close-on-content-click": false,
          location: "bottom start",
          transition: "scale-transition",
          "min-width": "290px",
          "max-width": "290px"
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_text_field, _mergeProps({
              "model-value": _ctx.localRecordedAt,
              label: _ctx.$t('milk.timeLabel'),
              "prepend-icon": "mdi-clock-time-four-outline",
              rules: [_ctx.rules.required],
              readonly: ""
            }, props, {
              variant: "outlined",
              density: "compact",
              color: "primary"
            }), null, 16, ["model-value", "label", "rules"])
          ]),
          default: _withCtx(() => [
            (_ctx.isRecordetAtPicker)
              ? (_openBlock(), _createBlock(_component_v_time_picker, {
                  key: 0,
                  modelValue: _ctx.localRecordedAt,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localRecordedAt) = $event)),
                    _ctx.onTimePicked
                  ],
                  format: "24hr",
                  locale: "ja",
                  "allowed-minutes": _ctx.allowedStep,
                  color: "primary",
                  onKeydownCapture: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                }, null, 8, ["modelValue", "allowed-minutes", "onUpdate:modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_v_select, {
          "model-value": _ctx.amount,
          "onUpdate:modelValue": _ctx.onChangeAmount,
          items: _ctx.milkChoice,
          "item-title": "value",
          "item-value": "id",
          label: _ctx.$t('milk.amountLabel'),
          variant: "outlined",
          density: "compact"
        }, null, 8, ["model-value", "onUpdate:modelValue", "items", "label"]),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "ml-1 body-1" }, "cc", -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_v_select, {
          "model-value": _ctx.milkCategory,
          "onUpdate:modelValue": _ctx.onChangeMilkCategory,
          items: _ctx.options,
          "item-title": "text",
          "item-value": "value",
          rules: [_ctx.rules.required],
          label: _ctx.$t('milk.milkTypeLabel'),
          variant: "outlined",
          density: "compact"
        }, null, 8, ["model-value", "onUpdate:modelValue", "items", "rules", "label"])
      ])
    ]),
    _: 1
  }, 8, ["class"]))
}